import  {baseActions}  from "./base.actions";

export const messageActions = {
    add,
    edit,
    gets,
    get,
    delete: _delete,
    getrecieverlist
};

function add(obj,func=null) {
    
    return baseActions.add(obj,'message',null,func)
}

function edit(obj,id,func=null) {
    return baseActions.edit(obj,'message',id,null,func);
}

function gets( page, perPage, sortField, sortOrder,filter,params=null) {
    return baseActions.gets('message', page, perPage, sortField, sortOrder,filter,params);
}

function get(id)
{
    return baseActions.get('message',id);
}

function getrecieverlist()
{
    return baseActions.getall('message','getrecieverlist');
}

function _delete(id,func=null)
{
    return baseActions.delete(id,'message',func);
}